
import { Firestore, collection, query, where, getDocs, doc } from "firebase/firestore";
import { Offer } from "@/types/offer";
import { offerConverter } from "./offer";

/**
 * Helper function to get offers for a location
 * Updated to use the offers collection instead of the deprecated campOffers collection
 */
export const getCampOffersForLocation = async (db: Firestore, locationId: string): Promise<Offer[]> => {
  try {
    // Early return if no locationId
    if (!locationId) {
      console.info("No locationId provided to getCampOffersForLocation");
      return [];
    }
    
    // Query Firestore to get all offers where locationRef == locationId
    const offersRef = collection(db, "offers");
    
    // Create a proper reference to the location document
    const locationRef = doc(db, "campLocations", locationId);
    
    // Use the reference in the query with the proper converter
    const q = query(
      offersRef, 
      where("locationRef", "==", locationRef)
    ).withConverter(offerConverter);
      
    const querySnapshot = await getDocs(q);
    
    if (querySnapshot.empty) {
      console.info("No offers found");
      return [];
    }
    
    // Map the documents to the Offer interface
    const offers = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    
    console.info(`Found ${offers.length} offers for location ${locationId}`);
    return offers;
  } catch (error) {
    console.error("Error getting offers for location:", error);
    // Return an empty array instead of throwing, to prevent render failures
    return [];
  }
};
